import VmWorkflowMode = h5_vm.VmWorkflowMode;
class VmHardwareUsbControllerInput {
   public inflatedDevice: any;
   public vmWorkflowMode: VmWorkflowMode;
   public selectedGuestOs: any;
   public vmConfigContext: any;
}
